import { TemplateMeasure } from "../bundles/entities.bundle";

export class TemplateMeasureGroup {
    templateMeasureGroupId: number;
    templateId: number;
    measureGroupTitle: string;
    submissionDate: Date;
    measures: Array<TemplateMeasure>;
    collapse: boolean;
}